import React from 'react';
import { NavBar } from '../../Modules/Navigation/components/NavBar/NavBar';
import PageContentCardContainer from '../../ui/Layout/PageContentCardContainer/PageContentCardContainer';
import DataDownload from '../../Modules/Data/features/DataDownload/DataDownload';

const DataDownloadPage = () => (
    <>
        <NavBar />
        <PageContentCardContainer>
            <DataDownload />
        </PageContentCardContainer>
    </>
);

export default DataDownloadPage;
